import { IFaireMoney } from "@faire/web-api/indigofair/data/IFaireMoney";
import { moneyOrZero } from "@faire/web/common/money";
import { MoneyMath } from "@faire/web/common/MoneyMath";

import { estimateTermsRatio } from "@faire/retailer/components/OpenWithFaire/OpenWithFairePotentialCreditBar/helpers";
import { useCreditSummaryStore } from "@faire/retailer/stores/domain/CreditSummaryStore";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

export const useNudge2Progress = () => {
  const { retailer } = useRetailerStore(["retailer"]);
  const { availableTermsLimit } = useCreditSummaryStore([
    "availableTermsLimit",
  ]);
  const isNegativeBalance = MoneyMath.lessThanZero(
    moneyOrZero(availableTermsLimit)
  );

  const availableTermsLimitCapped = isNegativeBalance
    ? IFaireMoney.build({
        amount_cents: 0,
        currency: availableTermsLimit?.currency,
      })
    : availableTermsLimit;

  const availableTermsRatio = estimateTermsRatio({
    numerator: availableTermsLimitCapped,
    denominator: retailer?.terms_limit,
  });

  return {
    availableTermsLimitCapped,
    totalTermsLimit: retailer?.terms_limit,
    availableTermsRatio,
  };
};
